import { LoginRenderer } from './loginRenderer';

export const loadLoginRenderer = async (): Promise<LoginRenderer> => {
  const { loginRenderer } = await import(/* webpackChunkName: "3-render-loginrenderer" */ './loginRenderer');

  return loginRenderer;
};
